export const CALLINGS = [
  {
    id: 1,
    name: "Ks. Kania Wojciech",
    dateOfBirth: "ur. 18 IV 1911 roku",
    placeOfBirth: "w Grądach,",
    dateOdDeth: "zmarł 04.12 2000 roku",
    placeOFDeth: "w Tarnowie.",
    present: "",
    path: "/images/callings/ksKania.jpg",
  },
  {
    id: 2,
    name: "Ks. Dobrzański Stefan",
    dateOfBirth: "ur. 04 VII 1915 roku",
    placeOfBirth: "w Grądach,",
    dateOdDeth: "zmarł 12 III 1999 roku",
    placeOFDeth: "w Tarnowie.",
    present: "",
    path: "/images/callings/ksDobrzanski.jpg",
  },
  {
    id: 3,
    name: "Ks. Pałach Stanisław",
    dateOfBirth: "ur. 22 XI 1919 roku",
    placeOfBirth: "w Mokrzyskach,",
    dateOdDeth: "zmarł 03 III 2004 roku",
    placeOFDeth: "w Warszawie.",
    present: "",
    path: "/images/callings/ksPalach.jpg",
  },
  {
    id: 4,
    name: "Ks. Wąsik Stanisław",
    dateOfBirth: "ur. 27 IV 1920 roku",
    placeOfBirth: "w Grądach,",
    dateOdDeth: "zmarł 25 XII 1987 roku",
    placeOFDeth: "w Bagnie.",
    present: "",
    path: "/images/callings/ksWasikS.jpg",
  },
  {
    id: 5,
    name: "Ks. Wąsik Jan",
    dateOfBirth: "ur. 04 V 1929 roku",
    placeOfBirth: "w Grądach,",
    dateOdDeth: "zmarł 11 VIII 1989 roku",
    placeOFDeth: "w Pile.",
    present: "",
    path: "/images/callings/ksWasikJ.jpg",
  },
  {
    id: 6,
    name: "O. Woda Franciszek",
    dateOfBirth: "ur. 28 II 1926 roku",
    placeOfBirth: "w Mokrzyskach,",
    dateOdDeth: "zmarł 2016 roku",
    placeOFDeth: "w Zambii.",
    present: "",
    path: "/images/callings/oWoda.jpg",
  },
  {
    id: 7,
    name: "Ks. Ręczak Jerzy",
    dateOfBirth: "ur. 08 II 1959 roku",
    placeOfBirth: "w Mokrzyskach.",
    dateOdDeth: "",
    placeOFDeth: "",
    present: "Obecnie pracuje w diecezji Częstochowskiej.",
    path: "/images/callings/ksReczak.jpg",
  },
  {
    id: 8,
    name: "Ks. Bełżek Dariusz",
    dateOfBirth: "ur. 18 XII 1966 roku",
    placeOfBirth: "w Porąbce Uszewskiej.",
    dateOdDeth: "",
    placeOFDeth: "",
    present: "Obecnie pracuje w diecezji Częstochowskiej.",
    path: "/images/callings/ksBelzek.jpg",
  },
  {
    id: 9,
    name: "S. Salomea Ewa Pabian",
    dateOfBirth: "ur. 05 VII 1964 roku",
    placeOfBirth: "w Oławie.",
    dateOdDeth: "",
    placeOFDeth: "",
    present: "Obecnie przebywa w klasztorze Sióstr Klarysek w Starym Sączu.",
    path: "/images/callings/sPabian.jpg",
  },
];
